export default __webpack_public_path__ + "92c17018f29672ae633d6db39b60f7b6.png";